export const buttonsStyles = [
  'button-style-01',
  'button-style-02',
  'button-style-03',
  'button-style-04',
  'button-style-05',
  'button-style-06',
  'button-style-07',
  'button-style-08',
  'button-style-09',
  'button-style-10',
  'button-style-11',
  'button-style-12',
  'button-style-13',
  'button-style-14',
  'button-style-15',
];
